import { Collapse as MuiCollapse, CollapseProps as MuiCollapseProps } from '@mui/material'
import styled from 'styled-components'

export type CollapsePropsType = MuiCollapseProps

const Collapse = styled(MuiCollapse)<CollapsePropsType>``
export default Collapse
